export default __webpack_public_path__ + "static/media/tortoise.8d89ddd8.ogg";